
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import MahkemeSecim from "@/components/inputs/MahkemeSecim.vue";
import SehirPicker from "@/components/pickers/SehirPicker.vue";
import NoterPicker from "@/components/pickers/NoterPicker.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import Dates from "@/components/inputs/Dates.vue";
import {IlamTipi} from "@/enum/IlamTipi";
import DosyaEsasNumarasi from "@/components/inputs/DosyaEsasNumarasi.vue";
import KararNumarasi from "@/components/inputs/KararNumarasi.vue";
import IlamTipiPicker from "@/components/pickers/IlamTipiPicker.vue";
import DosyaTuruPicker from "@/components/pickers/DosyaTuruPicker.vue";
import YevmiyeNumarasi from "@/components/inputs/YevmiyeNumarasi.vue";
import {defaults} from "xml2js";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import IhtiyatiHacizAlacakKalemiForm from "@/components/forms/alacak-kalemi/IhtiyatiHacizAlacakKalemiForm.vue";
import MahkemeForm from "@/components/forms/MahkemeForm.vue";

@Component({
  computed: {
    defaults() {
      return defaults
    }
  },
  components: {
    MahkemeForm,
    IhtiyatiHacizAlacakKalemiForm, FormDialog,
    YevmiyeNumarasi,
    DosyaTuruPicker,
    IlamTipiPicker,
    KararNumarasi,
    DosyaEsasNumarasi,
    Dates,
    FormWrapper,
    MahkemeSecim,
    SehirPicker,
    NoterPicker,
  },
})
export default class IlamBilgileriForm extends Mixins(ObjectInputMixin) {
  @Prop({default: false}) yevmiyeNoGoster!: boolean;
  @Prop({type: Object}) defaultValues!: any;
  /** Çağıran formlar geçiyor; bu formda alan farklılaştırması yapılmıyor ama arayüz korunuyor. */
  @Prop() takipTipiId!: number;

  ilamTipi = IlamTipi;
  mahkemeData: any = {};

  mounted(){
    if (!this.localValue.ilami_veren_kurum && this.localValue.ozel_mahkeme_isim){
      this.localValue.ilami_veren_kurum = this.localValue.ozel_mahkeme_isim
    }
  }

  /**
   * Dosya Türü listesini mahkemenin ilam türüne göre filtrelemek için kullanılır.
   *
   * Eskiden yalnızca `yargi_birimi.ilam_turu_id` okunuyordu; MahkemeEntity'de `yargi_birimi`
   * düz metin olarak tipli olduğu için getter pratikte hep null dönüyor ve filtre hiç
   * çalışmıyordu (kullanıcıya mahkemeye ait olmayan tüm dosya türleri listeleniyordu).
   * Kayıt kaynağına göre değer üç farklı şekilde gelebildiğinden hepsi sırayla deneniyor.
   */
  get ilamId() {
    const mahkeme: any = this.mahkemeData;
    if (!mahkeme)
      return null;
    return mahkeme.ilamTuru ?? mahkeme.yargi_birimi?.ilam_turu_id ?? mahkeme.ilam_turu_id ?? null;
  }

  get ilamOzetiRule() {
    if (this.localValue.ilam_ozeti) {
      if (this.localValue.ilam_ozeti.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return 'Lütfen bu alanı doldurun.';
  }
}
